import ErrorOutlinedIcon from "@mui/icons-material/ErrorOutlined";
import DoneIcon from "@mui/icons-material/Done";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";

export const statusColors = {
    'success': {background: '#1de9b6', icon: '#00bfa5'},
    'failed': {background: '#ef9a9a', icon: '#ef5350'},
    'pending': {background: '#bdbdbd', icon: '#616161'},
    'done': {background: '#1de9b6', icon: '#00bfa5'}
};

export const getStatusIcon = (publishingStatus) => {
    const icons = {
        'success': <DoneIcon style={{color: statusColors['success'].icon}}/>,
        'failed': <ErrorOutlinedIcon style={{color: statusColors['failed'].icon}}/>,
        'pending': <HourglassTopIcon style={{color: statusColors['pending'].icon}}/>,
    };
    publishingStatus = publishingStatus === 'done' ? 'success' : publishingStatus;
    return icons[publishingStatus];
};
